import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Action } from '@radix-ui/react-toast';

const ToastAction = React__default.forwardRef((_a, ref) => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsx(Action, Object.assign({
    ref: ref,
    className: className
  }, props, {
    children: children
  }));
});
ToastAction.displayName = "ToastAction";

export { ToastAction };
